import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { ProductType } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface ProductTypeWatchProps {
    productType?: ProductType;
}

export function ProductTypeInput({ disabled = false }: Props) {
    const { productType } = useFormContext<ProductTypeWatchProps>().getValues();
    const productTypeQueryResult = useQuery({
        queryKey: ['productTypes'],
        queryFn: () =>
            Api.Products.Types.getProductTypes({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: productType ? [productType] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Alcohol Type"
            name="productTypeId"
            loading={productTypeQueryResult.isLoading}
            multiple={false}
            options={productTypeQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: ProductType,
                    value?: ProductType | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
                getOptionKey(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.id}-${option.productCategoryId}`;
                },
            }}
        />
    );
}
